// Shared options for the Expenses module

// Expense lifecycle statuses (expenses_master.exp_status)
export const EXPENSE_STATUSES = [
    { value: "Pending", label: "Pending" },
    { value: "Approved", label: "Approved" },
    { value: "Rejected", label: "Rejected" },
    { value: "Cancel", label: "Cancel" },
    { value: "Paid", label: "Paid" },
    { value: "Partially Paid", label: "Partially Paid" },
];

export const EXPENSE_STATUS_COLORS = {
    Pending: "gold",
    Approved: "green",
    Rejected: "red",
    Cancel: "default",
    Paid: "blue",
    "Partially Paid": "purple",
};

// Approval sub-status (expenses_master.approved_status)
export const APPROVAL_STATUS_COLORS = {
    Pending: "gold",
    Approved: "green",
    Rejected: "red",
    Cancel: "default",
};
